import { AbstractApiClient, AmplifyServerApiClient, RemoteServerApiClient } from '../providers/apiClient';

class Container {
    protected currentApiClient: AbstractApiClient;

    constructor() {
        this.currentApiClient = process.env.REACT_APP_CONTAINER_API_CLIENT !== 'remoteServer' ?
            new AmplifyServerApiClient() :
            new RemoteServerApiClient();
    }

    get apiClient() {
        return this.currentApiClient;
    }
}

const container = new Container();

export default container;
